import { useQuery } from '@tanstack/react-query';
import { fetchPartnerLocations } from '../data-provider/partner-location-list';
import type { partnerLocationParams } from '../data-provider/partner-location-list/api';

export const useGetPartnerLocations = (params: partnerLocationParams) => {
  return useQuery({
    queryKey: ['savers-partner-locations-list', params.customerKey],
    queryFn: () => fetchPartnerLocations(params),
    staleTime: Number.POSITIVE_INFINITY,
    enabled: Boolean(params.customerKey),
  });
};
